import './ToastContainer.css'

export const ToastContainer = () =>{
    return(<div id="toastContainer"></div>)
}